import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import React from 'react';
import { BarBadge, BarButton } from '../alliance/bar-controls';
import { CartContext } from '../../contexts/cart-context';
import { getDetailsAll } from '../../routes/leads-map/purchase-utils';

/**
 * The cart in the App Bar's actions slot. Green badge (top right) = leads in
 * the instant-purchase cart, blue badge (bottom right) = subscriptions being
 * created. Opens the cart drawer.
 */
export function CartButton() {
  // Context
  const { state, dispatch } = React.useContext(CartContext);

  const cartItems =
    state.cart && state.cart.CartId && state.cart.CartItems?.length
      ? state.cart.CartItems
      : [];
  const leadCount = getDetailsAll({ data: cartItems }).quantity || 0;
  const subsCount = state.subs.length || 0;

  const label = [
    'Cart',
    leadCount ? `${leadCount} leads` : '',
    subsCount ? `${subsCount} subscriptions` : '',
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <BarButton
      square
      open={state.cartOpen}
      aria-label={label}
      title="Cart"
      onClick={() => dispatch({ type: 'TOGGLE_CART' })}
      sx={{ mr: '6px' }}
    >
      <ShoppingCartIcon sx={{ fontSize: 21 }} />
      <BarBadge
        count={leadCount}
        title="Leads in cart"
        background="#00C868"
        color="#03182E"
        position={{ top: -8, right: -12 }}
      />
      <BarBadge
        count={subsCount}
        title="Subscriptions"
        background="#0094FF"
        color="#ffffff"
        position={{ bottom: -8, right: -8 }}
      />
    </BarButton>
  );
}
